var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-white p-2 w-full h-18 shadow-2xl confirm-button",class:_vm.statusClass,on:{"click":function($event){return _vm.$emit('check', true)}}},[_vm._v(" 확인 ")])}
var staticRenderFns = []

export { render, staticRenderFns }